import { Deserializable } from '../_common/deserializable';

export class TxScMsg  implements Deserializable{
    id: number;
    shortCode: string;
    lang: string;
    subInvalidMsg: string;
    unsubInvalidMsg: string;
    subHelpMsg: string;
    unsubHelpMsg: string;
    unsubAllMsg: string;
    createdAt: number;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
